export default "__VITE_ASSET__uwhgxR7X__"